// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// axios
// import axios from 'axios'
import axios from 'axios'
import qs from 'qs'
// 引入vuex
import store from './vuex/store'
// 解决移动端点击延迟
import fastClick from 'fastclick'
// 重置样式
import 'styles/reset.css'
import 'styles/border.css'
// swiper翻页
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
// px自动转换成rem
import './utils/rem'
// 引入动画
import 'vue2-animate/dist/vue2-animate.min.css'
// 引入Element
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 引入国际化
import i18n from './i18n/i18n'
// 引入滚动插件
import { HappyScroll } from 'vue-happy-scroll'
import 'vue-happy-scroll/docs/happy-scroll.css'
// 引入视频
import VueVideoPlayer from 'vue-video-player'
// import 'video.js/dist/lang/zh-CN'
import 'video.js/dist/video-js.css'
// 全局注册
Vue.config.productionTip = false
fastClick.attach(document.body)
Vue.use(VueAwesomeSwiper)
Vue.use(ElementUI)
Vue.use(VueVideoPlayer)
Vue.component('happy-scroll', HappyScroll)
Vue.prototype.$axios = axios
Vue.prototype.$qs = qs
Vue.prototype.bus = new Vue()

/* router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})
Vue.prototype.$http = axios */
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js